import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-98c18e2a")

_pushScopeId("data-v-98c18e2a")
const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = { class: "user-info-cont" }
const _hoisted_3 = { class: "user-info-name" }
const _hoisted_4 = { class: "user-info-list" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 上次登录时间： ")
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "user-info-list" }, [
  /*#__PURE__*/_createTextVNode(" 上次登录地点： "),
  /*#__PURE__*/_createVNode("span", null, "北京")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, [
  /*#__PURE__*/_createVNode("span", null, "航班总览")
], -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 待起飞 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("已起飞 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("已到达 ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("已停班 ")
const _hoisted_12 = { class: "grid-content grid-con-1" }
const _hoisted_13 = /*#__PURE__*/_createVNode("i", { class: "el-icon-user-solid grid-con-icon" }, null, -1)
const _hoisted_14 = { class: "grid-cont-right" }
const _hoisted_15 = { class: "grid-num" }
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "用户总量", -1)
const _hoisted_17 = { class: "grid-content grid-con-2" }
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-position grid-con-icon" }, null, -1)
const _hoisted_19 = { class: "grid-cont-right" }
const _hoisted_20 = { class: "grid-num" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", null, "航班总量", -1)
const _hoisted_22 = { class: "grid-content grid-con-3" }
const _hoisted_23 = /*#__PURE__*/_createVNode("i", { class: "el-icon-tickets grid-con-icon" }, null, -1)
const _hoisted_24 = { class: "grid-cont-right" }
const _hoisted_25 = { class: "grid-num" }
const _hoisted_26 = /*#__PURE__*/_createVNode("div", null, "订单数量", -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("div", { class: "clearfix" }, [
  /*#__PURE__*/_createVNode("span", null, "新消息")
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" 心想事成，为梦而行 ")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("上网不涉密，涉密不上网")
_popScopeId()

import store from '@/store';
import { UserService } from '@/utils/api/user';
import { ElMessage } from 'element-plus';
import { defineComponent, onMounted, ref } from 'vue';
import { parseDate } from '@/utils/day';


export default _defineComponent({
  expose: [],
  setup(__props) {

const name = ref('Zeiion');
const role = '特权管理员';
const time = ref(parseDate(new Date()));
const avatarURL =
  'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg';
const infoList = [
  {
    status: '',
    title: '有新用户发来的订单',
  },
];
const userAmount = ref(12);
const orderAmount = ref(123);
const flightAmount = ref(1234);
onMounted(() => {
  name.value = store.state.userInfo.username;
  UserService.getAllAmount().then((res) => {
    if (res.status === 200) {
      userAmount.value = res.data.numOfPassengers;
      orderAmount.value = res.data.numOfOrders;
      flightAmount.value = res.data.numOfFlights;
    } else {
      ElMessage('获取信息失败');
    }
  });
});

return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withId(() => [
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withId(() => [
            _createVNode(_component_el_card, {
              shadow: "hover",
              class: "mgb20",
              style: {"height":"252px"}
            }, {
              default: _withId(() => [
                _createVNode("div", _hoisted_1, [
                  _createVNode(_component_el_avatar, {
                    src: avatarURL,
                    class: "user-avator",
                    alt: name.value,
                    size: 120,
                    fit: "fill"
                  }, null, 8, ["alt"]),
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", _hoisted_3, _toDisplayString(name.value), 1),
                    _createVNode("div", null, _toDisplayString(role))
                  ])
                ]),
                _createVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createVNode("span", null, _toDisplayString(time.value), 1)
                ]),
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              shadow: "hover",
              style: {"height":"252px"}
            }, {
              header: _withId(() => [
                _hoisted_7
              ]),
              default: _withId(() => [
                _hoisted_8,
                _createVNode(_component_el_progress, {
                  percentage: 60.1,
                  color: "#42b983"
                }, null, 8, ["percentage"]),
                _hoisted_9,
                _createVNode(_component_el_progress, {
                  percentage: 19.9,
                  color: "#f1e05a"
                }, null, 8, ["percentage"]),
                _hoisted_10,
                _createVNode(_component_el_progress, { percentage: 14.5 }, null, 8, ["percentage"]),
                _hoisted_11,
                _createVNode(_component_el_progress, {
                  percentage: 5.5,
                  color: "#f56c6c"
                }, null, 8, ["percentage"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withId(() => [
            _createVNode(_component_el_row, {
              gutter: 20,
              class: "mgb20"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      "body-style": { padding: '0px' }
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_12, [
                          _hoisted_13,
                          _createVNode("div", _hoisted_14, [
                            _createVNode("div", _hoisted_15, _toDisplayString(userAmount.value), 1),
                            _hoisted_16
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      "body-style": { padding: '0px' }
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createVNode("div", _hoisted_19, [
                            _createVNode("div", _hoisted_20, _toDisplayString(flightAmount.value), 1),
                            _hoisted_21
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_card, {
                      shadow: "hover",
                      "body-style": { padding: '0px' }
                    }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createVNode("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, _toDisplayString(orderAmount.value), 1),
                            _hoisted_26
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_card, {
              shadow: "hover",
              style: {"height":"403px"}
            }, {
              header: _withId(() => [
                _hoisted_27
              ]),
              default: _withId(() => [
                _createVNode(_component_el_table, {
                  "show-header": false,
                  data: infoList,
                  style: {"width":"100%"}
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_table_column, { width: "40" }, {
                      default: _withId((scope) => [
                        _createVNode(_component_el_checkbox, {
                          modelValue: scope.row.status,
                          "onUpdate:modelValue": ($event: any) => (scope.row.status = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_table_column, null, {
                      default: _withId((scope) => [
                        _createVNode("div", {
                          class: ["news-item", {
                    'news-item-del': scope.row.status,
                  }]
                        }, _toDisplayString(scope.row.title), 3)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { gutter: 20 }, {
      default: _withId(() => [
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withId(() => [
            _createVNode(_component_el_card, {
              shadow: "hover",
              style: {"text-align":"center"}
            }, {
              default: _withId(() => [
                _hoisted_28
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 12 }, {
          default: _withId(() => [
            _createVNode(_component_el_card, {
              shadow: "hover",
              style: {"text-align":"center"}
            }, {
              default: _withId(() => [
                _hoisted_29
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})